export default [
    {
        path: 'saida',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-saida' */
            '@/views/almoxarifado/saida/Index'
        ),
        redirect: 'saida/index',
        children: [
            {
                name: 'almoxarifado-saida-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-saida' */
                    '@/views/almoxarifado/saida/List.vue'
                ),
            },
            {
                name: 'almoxarifado-saida-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-saida' */
                    '@/views/almoxarifado/saida/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-saida-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-saida' */
                    '@/views/almoxarifado/saida/Form.vue'
                ),
            },
        ],
    },
]